import { css } from '@emotion/css';

export const hourInputStyles = css`
  .MuiInputBase-input {
    text-overflow: ellipsis;
  }
`;
